// calculateAndAddToCart fonksiyonu - tarih formatını güncelle
async function calculateAndAddToCart() {
  // Get dates from lightpick input
  const dateInput = document.querySelector("#quick-date-picker");
  if (!dateInput || !dateInput.value) {
    Swal.fire({
      title: window.popupTranslations.error_date_title,
      icon: "warning",
      confirmButtonText: window.popupTranslations.error_date_button,
    });
    return;
  }

  // Parse date range from lightpick format: "11/05/2025 - 10/06/2025"
  const dateRange = dateInput.value.trim();
  const dateParts = dateRange.split(" - ");

  // Yalnızca giriş seçilmiş (çıkış henüz seçilmedi) — "format hatalı" demek yanıltıcı.
  if (dateParts.length === 1 && parseDate(dateParts[0])) {
    const isEn = (document.documentElement.lang || "").toLowerCase().startsWith("en");
    Swal.fire({
      title: isEn ? "Please select a check-out date." : "Çıkış tarihi seçilmedi.",
      text: isEn
        ? "After picking your check-in date, select a check-out date from the calendar."
        : "Giriş tarihini seçtiniz; takvimden çıkış tarihini de seçin.",
      icon: "info",
      confirmButtonText: window.popupTranslations.error_date_button,
    });
    return;
  }

  if (dateParts.length !== 2) {
    Swal.fire({
      title: window.popupTranslations.error_date_title,
      text: window.popupTranslations.error_date_text,
      icon: "warning",
      confirmButtonText: window.popupTranslations.error_date_button,
    });
    return;
  }

  // Parse dates (DD/MM/YYYY format)
  const checkInDate = parseDate(dateParts[0]);
  const checkOutDate = parseDate(dateParts[1]);

  if (!checkInDate || !checkOutDate) {
    Swal.fire({
      title: window.popupTranslations.error_date_title,
      text: window.popupTranslations.error_date_text,
      icon: "warning",
      confirmButtonText: window.popupTranslations.error_date_button,
    });
    return;
  }

  // Calculate number of days
  const diffTime = Math.abs(checkOutDate - checkInDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 100) {
    // Minimum 100 days
    Swal.fire({
      title: window.popupTranslations.error_date_minimum,
      icon: "warning",
      confirmButtonText: window.popupTranslations.error_date_button,
    });
    return;
  }

  // Get price data from product metafields
  let priceRangeData = window.addToCartData.price_range_data;

  // Parse the JSON string
  if (priceRangeData && priceRangeData !== "") {
    try {
      priceRangeData = JSON.parse(priceRangeData);
    } catch (e) {
      Swal.fire({
        title: window.popupTranslations.cant_parse_price,
        icon: "error",
        confirmButtonText: window.popupTranslations.error_button,
      });
      return;
    }
  } else {
    Swal.fire({
      title: window.popupTranslations.no_price_found,
      icon: "error",
      confirmButtonText: window.popupTranslations.error_button,
    });
    return;
  }

  if (
    !priceRangeData.MonthlyPrices ||
    !priceRangeData.MonthlyPrices["12_12"] ||
    !priceRangeData.MonthlyPrices["12_12"]["cash"]
  ) {
    Swal.fire({
      title: window.popupTranslations.price_format_error,
      icon: "error",
      confirmButtonText: window.popupTranslations.error_button,
    });
    return;
  }

  // Maksimum 12 ay (365 gün) veya 12 ay + 1 gün (366 gün) için hata verme
  if (diffDays > 365 && diffDays !== 366) {
    Swal.fire({
      title: window.popupTranslations.error_date_maximum,
      icon: "warning",
      confirmButtonText: window.popupTranslations.error_button,
    });
    return;
  }

  // Get 12 month cash price
  const monthlyPrice = priceRangeData.MonthlyPrices["12_12"]["cash"];
  const months = Math.ceil(diffDays / 30);
  const dailyRate = monthlyPrice / 360; // 12 months = 360 days
  const totalRentPrice = diffDays * dailyRate;

  // Calculate additional fees
  const generalExpenses = priceRangeData.GeneralExpenses;
  const monthsForFees = Math.ceil(diffDays / 30);

  const maintenanceFeeMonthly = generalExpenses.MaintenanceFee || 0;
  const billingFeeMonthly = generalExpenses.BillingFee || 0;
  const cleaningFee = generalExpenses.CleaningFee || 0;

  const totalMaintenanceFee = maintenanceFeeMonthly * monthsForFees;
  const totalBillingFee = billingFeeMonthly * monthsForFees;

  // Calculate total price (rent + fees)
  const totalPrice =
    totalRentPrice + totalMaintenanceFee + totalBillingFee + cleaningFee;

  // Prepare data for API
  const orderData = {
    product_id: window.addToCartData.product_id,
    product_handle: window.addToCartData.product_handle,
    product_title: window.addToCartData.product_title,
    total_price: Math.round(totalPrice * 100) / 100,
    rent_price: Math.round(totalRentPrice * 100) / 100,
    maintenance_fee: totalMaintenanceFee,
    billing_fee: totalBillingFee,
    cleaning_fee: cleaningFee,
    check_in_date: formatDate(checkInDate),
    check_out_date: formatDate(checkOutDate),
    days: diffDays,
    months: months,
    payment_type: "cash",
    daily_rate: Math.round(dailyRate * 100) / 100,
    monthly_price: monthlyPrice,
  };

  const loadingPopup = Swal.fire({
    title: window.popupTranslations.please_wait,
    icon: "info",
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const pageType = window.addToCartData.page_type;

  const clearResponse = await fetch("/cart/clear.js", {
    method: "POST",
  });

  if (!clearResponse.ok) {
    Swal.fire({
      title: window.popupTranslations.error_clear_cart,
      icon: "error",
      confirmButtonText: window.popupTranslations.error_button,
    });
    return;
  }

  const addToCartResponse = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: window.addToCartData.product_id,
      quantity: 1,
    }),
  });

  if (!addToCartResponse.ok) {
    Swal.fire({
      title: window.popupTranslations.error_title,
      text: window.popupTranslations.error_text,
      icon: "error",
      confirmButtonText: window.popupTranslations.error_button,
    });
    return;
  }

  const addToCartData = await addToCartResponse.json();

  if (pageType === "cart") {
    const cart_element = document.querySelector("alternative-cart");
    if (cart_element) {
      cart_element.writeSessionStorage();
    }
  }

  loadingPopup.close();

  setTimeout(() => {
    // Linke daire handle'ını da ekle: paylaşıldığında (sepet cookie'si taşınmaz)
    // alıcı tarafı daireyi sepete ekleyip doğru cart'ı açabilsin (cart-alternative.liquid bootstrap).
    const handle = window.addToCartData && window.addToCartData.product_handle;
    window.location.href = `${window.Shopify.routes.root}cart?${ReservationUrl.buildQuery(handle, dateParts[0], dateParts[1])}`;
  });
}

// Rezervasyon linki: /cart?product=<handle>&start=YYYY-MM-DD&end=YYYY-MM-DD
// (encode gerektirmeyen okunaklı format). Eski ?dates=DD/MM/YYYY - DD/MM/YYYY linkleri de okunur.
const ReservationUrl = {
  DISPLAY_RE: /^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/,
  ISO_RE: /^(\d{4})-(\d{1,2})-(\d{1,2})$/,

  // "10/10/2026" → "2026-10-10"
  toIso(displayDate) {
    const m = String(displayDate || '').trim().match(this.DISPLAY_RE);
    return m ? `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}` : null;
  },

  // "2026-10-10" → "10/10/2026"
  toDisplay(isoDate) {
    const m = String(isoDate || '').trim().match(this.ISO_RE);
    return m ? `${m[3].padStart(2, '0')}/${m[2].padStart(2, '0')}/${m[1]}` : null;
  },

  buildQuery(handle, startDisplay, endDisplay) {
    const parts = [];
    if (handle) parts.push(`product=${encodeURIComponent(handle)}`);
    parts.push(`start=${this.toIso(startDisplay)}`, `end=${this.toIso(endDisplay)}`);
    return parts.join('&');
  },

  // URL'den tarihleri DD/MM/YYYY olarak döndürür: ["10/10/2026", "18/01/2027"] ya da null.
  read(search = window.location.search) {
    const params = new URLSearchParams(search);
    const start = this.toDisplay(params.get('start'));
    const end = this.toDisplay(params.get('end'));
    if (start && end) return [start, end];

    const legacy = (params.get('dates') || '').split(' - ');
    if (legacy.length === 2 && this.toIso(legacy[0]) && this.toIso(legacy[1])) {
      return [legacy[0].trim(), legacy[1].trim()];
    }
    return null;
  },

  // Eski formatla gelen linki adres çubuğunda yeni formata çevirir (sayfa yenilenmez).
  normalizeAddressBar() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('dates')) return;
    const dates = this.read();
    if (!dates) return;
    const query = this.buildQuery(params.get('product'), dates[0], dates[1]);
    history.replaceState(history.state, '', `${window.location.pathname}?${query}${window.location.hash}`);
  },
};
window.ReservationUrl = ReservationUrl;

// Helper functions
function parseDate(dateStr) {
  const parts = dateStr.trim().split('/');
  if (parts.length !== 3) return null;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  return new Date(year, month, day);
}

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}



// initDatesAndPrices ve formatPrice fonksiyonları
function initDatesAndPrices() {
  moment.locale(document.documentElement.lang);
  const allDataPrices = document.querySelectorAll("[data-price]");
  const allDataDates = document.querySelectorAll("[data-date]");
  const allForeignCurrencyInfo = document.querySelectorAll(".foreign-currency-only");
  const allBuildingAges = document.querySelectorAll("[data-age]");

  allForeignCurrencyInfo.forEach((info) => {
    if (window.currencySelector.name !== "TRY") {
      info.style.display = "block";
    } else {
      info.style.display = "none";
    }
  });

  allBuildingAges.forEach((age) => {
    const raw = age.dataset.age.trim();
    const currentYear = new Date().getFullYear();
    let result;

    if (/^\d{4}$/.test(raw)) {
      const year = Number(raw);
      result = currentYear - year;
      if (result < 0) result = 0;
    } else {
      const match = raw.match(/\d+/);
      result = match ? Number(match[0]) : 0;
    }

    age.textContent = window.translations.building_age.replace("%value%", result);
  });

  allDataPrices.forEach((price) => {
    if (price.dataset.skipFormat === 'true') {
      return;
    }

    const currentText = price.textContent.trim();
    if (currentText && (currentText.includes('TL') || currentText === '-' || currentText.includes('₺'))) {
      return;
    }

    const priceValue = price.dataset.price;
    if (!priceValue || priceValue === 'undefined' || priceValue === 'null' || priceValue.trim() === '') {
      if (currentText && currentText !== '') {
        return;
      }
      price.textContent = '-';
      return;
    }

    const formattedPrice = window.formatPrice(priceValue, 0);
    if (price.textContent.includes("%value%")) {
      price.textContent = price.textContent.replace("%value%", formattedPrice);
    } else {
      price.textContent = formattedPrice;
    }
  });

  const today = moment();
  allDataDates.forEach((date) => {
    const dateValue = moment(date.dataset.date, "YYYY-MM-DD");
    if (dateValue.isAfter(today)) {
      date.textContent = dateValue.format("DD MMMM YYYY");
    } else {
      date.textContent = moment().format("DD MMMM YYYY");
    }
  });
}

function formatPrice(price, decimal = 2) {
  const basePrice = parseFloat(price);
  if (!isFinite(basePrice)) {
    return '-';
  }
  if (!window.currencySelector || typeof window.currencySelector !== 'object') {
    window.currencySelector = {
      name: "TRY",
      rate: 1,
      symbol: "TL",
    };
  }
  let { name, rate } = window.currencySelector;
  const currencyCode = (typeof name === 'string' && name.trim() !== '') ? name.trim() : "TRY";
  const numericRate = Number(rate);
  const safeRate = isFinite(numericRate) ? numericRate : 1;
  const convertedPrice = basePrice * safeRate;
  const formattedPrice = Number(convertedPrice).toLocaleString("tr-TR", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: decimal,
  });
  const priceWithoutCurrency = formattedPrice.replace("₺", "").replace("TRY", "");
  if (currencyCode === "TRY") {
    return `${priceWithoutCurrency} TL`;
  }
  return `${priceWithoutCurrency}`;
}

// Only initialize once when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initDatesAndPrices);
} else {
  initDatesAndPrices();
}

window.initDatesAndPrices = initDatesAndPrices;
window.formatPrice = formatPrice;
window.calculateAndAddToCart = calculateAndAddToCart;
